var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.cellType,_vm._g(_vm._b({tag:"component",staticClass:"header-content-cell"},'component',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"header-column"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }